
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seminars/seminarDetails",
      function () {
        return require("private-next-pages/seminars/seminarDetails.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seminars/seminarDetails"])
      });
    }
  